// w37 Pari — variant that renders the standalone HTML at
// /templates/pari.html (twilight fairy-tale tunnel-book wedding
// invitation: deep purple-blue + dawn + pale gold + dusty rose +
// lavender, Cinzel + Cormorant Garamond + Tangerine; layered parallax
// hero with arches, balloons, butterflies, sparkles; scroll-reveal
// sections, live countdown, wishes wall) inside a full-bleed iframe.
//
// Flat .html — NOT a nested index.html. Go's http.FileServer
// 301-redirects any request ending in /index.html to the bare
// directory, which then falls through to the SPA and renders the wrong
// template. Every static template in this repo is a flat file.
//
// The HTML's customizer accepts DD.MM.YYYY directly — names/date/time/
// venue/address pass through raw on the query string.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/pari.html";

export function PariStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.mapUrl) params.set("map_url", t.mapUrl);
  if (ctx.slug) params.set("slug", ctx.slug);
  // ?audio=/music/<id>.mp3 — owner-picked soundtrack from the
  // curated MusicSelector library. Empty/unset = silent card.
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Pari"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#1a1530",
      }}
    />
  );
}
